import { render } from "./SalesPriceList.vue?vue&type=template&id=37b84050&scoped=true&ts=true"
import script from "./SalesPriceList.vue?vue&type=script&lang=ts"
export * from "./SalesPriceList.vue?vue&type=script&lang=ts"

import "./SalesPriceList.vue?vue&type=style&index=0&id=37b84050&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b84050"]])

export default __exports__